import React, { useState, useEffect } from "react";

import Modal from "react-bootstrap/Modal";

import moment from "moment";

import * as Constant from "../../../Constant.js";
import axios from "@app/lib/axios";

import AcceptContractTable from "../Contract/List/Accept.js";

import ContractComponent from "../Contract/List/Component.js";

const AcceptContractModal = ({ nursery_id, hide, bizApp, serviceAppList, appAuthTypeList, nurseryInfo, list, contain555, request_date }) => {
    const [bizAppMap, setBizAppMap] = useState(false);
    const [contractList, setContractList] = useState(false);
    const [use555, setUse555] = useState(false);
    const [branchName, setBranchName] = useState(false);

    useEffect(() => {
        initModal(bizApp, list);
        return () => {};
    }, [nursery_id, bizApp, nurseryInfo, list]);
    const initModal = (bizApp, list) => {
        if (bizApp && list) {
            const newBizAppMap = ContractComponent.func.getBizAppMap(bizApp, onChangeBizAppFold, true);
            list.sort((a, b) => {
                return a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age;
            });
            setContractList(list);
            updateContractTotal(newBizAppMap, list);
        }
    };
    const updateContractTotal = (bizAppMap, list) => {
        if (bizAppMap) {
            let newBizAppMap = { ...bizAppMap };
            let newBranchName = {};
            Object.keys(bizAppMap).forEach((a) => {
                newBizAppMap[a].count = 0;
                newBizAppMap[a].count_org = 0;
                newBizAppMap[a].count_new = 0;
                newBizAppMap[a].quantity = 0;
                newBizAppMap[a].quantity_org = 0;
            });
            list.forEach((c) => {
                if (c.is555) return;
                Object.keys(bizAppMap).forEach((a) => {
                    if(c.app_auth[a] && newBizAppMap[a].info && newBizAppMap[a].info.contractUseTas) {
                        if(c.app_auth[a].approval === "AP") {
                            newBizAppMap[a].count_org++;
                            newBizAppMap[a].quantity_org += Number(c[newBizAppMap[a].info.quantity.field[0]]);
                        } else if (c.app_auth[a].approval_org === "WT") {
                            newBizAppMap[a].count_new++;
                            if (c.app_auth[a].approval === "WT") newBizAppMap[a].count++;
                            newBizAppMap[a].quantity += Number(c[newBizAppMap[a].info.quantity.field[0]]);
                        }
                        if (!newBranchName[a]) newBranchName[a] = c.app_auth[a].branch_name;
                    }
                });
            });
            setBizAppMap(newBizAppMap);
            if (!branchName) setBranchName(newBranchName);
        }
    };
    const updateContractList = (list) => {
        // list.sort((a, b) => {
        //     return a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age;
        // });
        setContractList(list);
        updateContractTotal(bizAppMap, list);
    };
    const onChangeBizAppFold = (app, bizApp, fold = undefined) => {
        let newBizAppMap = { ...bizApp };
        newBizAppMap[app].fold = fold == undefined ? !newBizAppMap[app].fold : fold;
        setBizAppMap(newBizAppMap);
    };

    const submitContract = (appId) => {
        const _list = [];

        console.debug('==========');

        list.forEach((c) => {
            const _c = { ...c };
            if (_c.app_auth) {
                const auth = { ..._c.app_auth };
                const filteredAuth = {};
                Object.keys(auth).forEach((a) => {
                    if (appId == a || appId == null) {
                        auth[a].approval = auth[a].approval == "WT" ? "AP" : auth[a].approval;
                        filteredAuth[a] = auth[a];
                    }
                });
                _c.app_auth = filteredAuth;
            }
            _list.push(_c);
        });
        axios({
            method: "post",
            url: `${Constant.API_DOMAIN}/api/contract/accept/${nursery_id}`,
            data: {
                contracts: _list,
                use555: use555,
            },
        })
            .then((res) => {
                const data = res.data;
                if (data.code === 200) {
                    if (appId) {
                        const result = data.result[appId];
                        if (window.confirm(`총 ${result.affectedRows}건의 계약이 처리 되었습니다.\n\n계약 승인 창을 닫고 원 관리 페이지로 이동하시겠습니까?`)) {
                            hide();
                            document.location.href = "./contract?type=view&id=" + nursery_id;
                        } else {
                            document.location.reload();
                        }
                    } else {
                        const result = data.result;
                        let total = 0;
                        let msg = "";
                        Object.keys(result).forEach((a) => {
                            total += data.result[a].affectedRows;
							let name = "";
							const sa = serviceAppList.find((sa) => sa.appId == a);
							if(sa) {
								name = sa.name;
							}
                            msg += ` - ${name} : ${data.result[a].affectedRows}건\n`;
                        });
                        if (window.confirm(`총 ${total}건의 계약이 처리 되었습니다.\n${msg}\n\n계약 승인 창을 닫고 원 관리 페이지로 이동하시겠습니까?`)) {
                            hide();
                            document.location.href = "./contract?type=view&id=" + nursery_id;
                        } else {
                            hide();
                            document.location.reload();
                        }
                    }
                } else if (res.data.code === 5001) {
                    const arr = res.data.exist_apps;
                    const names = [];
                    arr.forEach((a) => {
                        let name = "";
                        const sa = serviceAppList.find((sa) => sa.appId == a);
                        if(sa) {
                            name = sa.name;
                        }
                        if (name) names.push(name);
                    });

                    alert(`해당 원에는 이미 [${names.join(", ")}] 계약이 존재하여 계약을 등록 할 수 없습니다.`);
                    return;
                } else {
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    return;
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    return (
        <>
            <Modal
                className={`modal-contract modal-container fullscreen-modal`}
                show={nursery_id > 0}
                onHide={() => {
                    if (window.confirm("계약 승인을 취소하시겠습니까?")) {
                        hide();
                    }
                }}
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title font-14">계약 승인</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {nurseryInfo && (
                        <div className="row m-0 bg-primary-light">
                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                <div className="page-header ml-2 mt-3 mb-3">
                                    <h3 className="">{nurseryInfo.name}</h3>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12" />
                        </div>
                    )}

                    <div className="container-fluid dashboard-content mt-3 pt-1 pb-2">
                        {nurseryInfo && (
                            <div className="row mb-3">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <table className="table table-bordered">
                                        <tr>
                                            <th className="bg-dark text-light" style={{ width: "100px" }}>
                                                계약 지사
                                            </th>
                                            <td className="text-danger">{nurseryInfo.branch_name}</td>
                                            <th className="bg-dark text-light" style={{ width: "100px" }}>
                                                승인 요청일
                                            </th>
                                            <td>{request_date}</td>
                                        </tr>
                                        <tr>
                                            <th className="bg-dark text-light" style={{ width: "100px" }}>
                                                원장 명
                                            </th>
                                            <td>{nurseryInfo.director}</td>
                                            <th className="bg-dark text-light" style={{ width: "100px" }}>
                                                주소
                                            </th>
                                            <td>{nurseryInfo.address}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        )}
                        <div className="row mb-3">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="div-table-contract ">
                                    <AcceptContractTable.AcceptTable
                                        tableId={"createTable"}
                                        bizApp={bizAppMap}
                                        serviceAppList={serviceAppList}
                                        appAuthTypeList={appAuthTypeList}
                                        list={contractList}
                                        branchName={branchName}
                                        changeList={updateContractList}
                                        acceptFunc={submitContract}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row m-3 mt-1">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-5 col-12"></div>
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-2 col-12" />
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                                <button className="btn btn-info btn-rounded btn-block" onClick={() => submitContract()}>
                                    전체 적용
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AcceptContractModal;
